export const LeafGlyph = ({ className = "h-3 w-3" }) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" className={className}>
    <path d="M12 21 C 12 14, 12 8, 12 3" strokeLinecap="round" />
    <path d="M12 15 C 7.5 13, 5.5 9, 6 5.5 C 10 7, 12 10.5, 12 15 Z" />
    <path d="M12 15 C 16.5 13, 18.5 9, 18 5.5 C 14 7, 12 10.5, 12 15 Z" />
  </svg>
);

const Marquee = ({ items, dark = false, fast = false }) => {
  const row = (
    <>
      {items.map((t, i) => (
        <span key={i} className="mx-8 inline-flex items-center gap-8">
          <span className="font-serif text-lg md:text-xl italic font-light whitespace-nowrap">{t}</span>
          <LeafGlyph className={`h-3.5 w-3.5 ${dark ? "text-sage" : "text-sage-deep"}`} />
        </span>
      ))}
    </>
  );
  return (
    <div
      data-testid="editorial-marquee"
      className={`overflow-hidden border-y hairline py-4 ${dark ? "bg-ink-deep text-cream border-white/10" : "bg-cream text-ink/80"}`}
    >
      <div className={`flex w-max ${fast ? "animate-marquee-fast" : "animate-marquee"}`}>
        <div className="flex">{row}</div>
        <div className="flex" aria-hidden="true">{row}</div>
      </div>
    </div>
  );
};

export default Marquee;
